import React from 'react';
import Accordion from './Accordion';
import $ from 'jquery';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import {
  dashboardData,
  isDataNameFilterForDining,
  getRestaurantDetails,
} from '../../dashboard/reducer';
import AddItemPopup from '../../dashboard/components/items/AddItemPopup';
import OutOfStockItems from '../../inventory/OutOfStockItems';
import {
  hideOrderTypePopup,
  addItemToBag,
  removeItemFromBag,
  goToCheckout,
  updateOrderIdDetails,
  restoreTaxDetails,
  showMobileSidebar,
  checkCartItemsAvailable,
  getTimings,
  parseStartTimeEndTime,
  showOrderPanel,
} from '../../dashboard/actions';
import '../../../public/css/OrderPanel.css';
import { ToastContainer, ToastMessage } from '../../../lib';
import {
  GetCartItems,
  getCartPriceDetails,
  setCheckout,
  parsePrice,
  GetOrderType,
  cookieValue,
  createModifierPath,
} from '../../../lib/helper.js';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { resetCheckout } from '../../checkout/actions';
import { getItemTaxes, updateCartDetails } from '../../../api/api';
import { get, find } from 'lodash';
import { getOrderDetails } from '../../dashboard/reducer';
import moment from 'moment';
import defaultMsg from '../../../translations/lang/en-US.json';

const ToastMessageFactory = React.createFactory(ToastMessage.animation);
var alertify = require('alertifyjs');

const Taxes = props => {
  return (
    <div>
      {props.tax.length > 0 ? (
        <div className="row order-calculations">
          <div className="col-md-12 col order-panel-bottom-details olo-client-theme-color bottom-space">
            <u style={{ letterSpacing: '1px' }}> {props.header}</u>
          </div>
          {props.tax.map((taxData, index) => {
            return (
              <div className="font-small-xs" key={index}>
                <div className="col-md-7 col sm-7 col-xs-7 order-panel-bottom-details">
                  {taxData.formattedTitle}
                </div>
                <div className="col-md-5 col sm-5 col-xs-5 order-panel-bottom-details order-panel-calculations-right">
                  {parsePrice(taxData.calculatedtaxamount)}
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

class OrderPanel extends React.Component {
  constructor(props) {
    super(props);
    const { currentTimeCompare, isNowAvialable } = this.isNowAvialable();
    this.expandItemList = this.expandItemList.bind(this);
    this.state = {
      currentItemClicked: '',
      openModal: false,
      itemsarray: [],
      updateCurrentItem: false,
      updatedOrderItemIndex: 0,
      checkout: false,
      loading: false,
      redirectingToCheckout: false,
      scrollableHeight: 0,
      topSpace: false,
      display: false,
      isSmallerDevice: false,
      editItem: false,
      addingToCart: '',
      showOutOfStock: false,
      currentTimeCompare,
      isNowAvialable,
      updateCartItem: false,
    };
    this.changeModifiersFromDashboard = this.changeModifiersFromDashboard.bind(
      this
    );
    this.checkBoxOnchangeHandlerFromDashboard = this.changeModifiersFromDashboard.bind(
      this
    );
    this.closeModal = this.closeModal.bind(this);
    this.addItemsToBag = this.addItemsToBag.bind(this);
    this.addItemToBag = this.addItemToBag.bind(this);
    if (this.props.orderPanelFromDashboard === 'true') {
      this.props.dispatch(resetCheckout());
      this.props.dispatch(restoreTaxDetails());
    }
    this.updateCheckoutDetails = this.updateCheckoutDetails.bind(this);
    this.updateOrder = this.updateOrder.bind(this);
    this.updatePannelDimensions = this.updatePannelDimensions.bind(this);
    this.closeCart = this.closeCart.bind(this);
  }

  getCurrentDate = () => Number(moment().format('x'));

  isNowAvialable() {
    const {
      restaurantDetails: { hoursOfOperation, minAdvanceNoticeTime },
    } = this.props;
    const currentDate = this.getCurrentDate();
    const weekDayConfigurationForToday = parseStartTimeEndTime(
      hoursOfOperation,
      currentDate
    );
    const dayTimings = !isEmpty(weekDayConfigurationForToday)
      ? weekDayConfigurationForToday.map(config =>
          getTimings(
            minAdvanceNoticeTime,
            currentDate,
            config.starttime,
            config.endtime,
            true,
            true
          )
        )
      : [false];

    let endTimePresent = null;
    if (weekDayConfigurationForToday && weekDayConfigurationForToday.length) {
      const splitEndTime = weekDayConfigurationForToday[0].endtime.split(':');
      endTimePresent = Number(splitEndTime[0]) * 60 + Number(splitEndTime[1]);
    }

    var currentTime = moment().get('hours') * 60 + moment().get('minutes');
    return {
      currentTimeCompare:
        endTimePresent !== null && parseFloat(endTimePresent - currentTime) > 0
          ? true
          : false,
      isNowAvialable: dayTimings && dayTimings.indexOf(true) !== -1,
    };
  }

  closeCart() {
    this.props.dispatch(showMobileSidebar(false));
  }

  updatePannelDimensions(nextProps) {
    const header = document.getElementById('mainHeader');
    const footer = document.getElementById('app-footer');
    const subHeader = document.getElementById('subHeader');

    const getOffset = element => (element !== null ? element.offsetHeight : 0);

    if (header && window.innerWidth > 768) {
      const scrollableHeight =
        window.innerHeight -
        getOffset(subHeader) -
        getOffset(header) -
        getOffset(footer);

      const topSpace = getOffset(header) + getOffset(subHeader);

      if (
        this.state.scrollableHeight !== scrollableHeight ||
        this.state.topSpace !== topSpace
      ) {
        this.setState({
          scrollableHeight: scrollableHeight,
          topSpace: topSpace,
          display: true,
          isSmallerDevice: false,
        });
        this.props.dispatch(showOrderPanel(true));
      }
    } else {
      const scrollableHeight = '100%',
        topSpace = '0px';

      if (
        (this.state.scrollableHeight !== scrollableHeight ||
          this.state.topSpace !== topSpace) &&
        window.innerWidth <= 768
      ) {
        this.setState({
          scrollableHeight: scrollableHeight,
          topSpace: topSpace,
          display: this.props.dashboardData.showMobileSidebar,
          isSmallerDevice: true,
        });
        this.props.dispatch(
          showOrderPanel(!!this.props.dashboardData.showMobileSidebar)
        );
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updatePannelDimensions);
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.props.dispatch(showOrderPanel(false));
  }

  closeModal() {
    this.setState({ openModal: false });
  }

  componentWillReceiveProps(nextProps) {
    if ((nextProps.authenticated || nextProps.guest) && this.state.checkout) {
      setCheckout(this);
    }
    if (this.state.isSmallerDevice) {
      this.setState({
        display: nextProps.dashboardData.showMobileSidebar,
      });
    } else {
      this.setState({
        display: true,
      });
    }
    this.updatePannelDimensions(nextProps);
  }

  switchModal(clickedItem) {
    if (this.state.currentItemClicked.isFromReorder) {
      /*modifierList[key]['selected'] = true;
      modifierList[key]['isChecked'] = true;
      modifierList[key]['wasChecked'] = false;
      modifierList[key]['addToBag'] = false;*/

      let tempObj = JSON.parse(JSON.stringify(clickedItem));
      if (tempObj.forced.length > 0) {
        tempObj.forced = createModifierPath(tempObj.forced, 'forced');
      }

      if (tempObj.optional.length > 0) {
        tempObj.optional = createModifierPath(tempObj.optional, 'optional');
      }

      if (!tempObj['basePrice']) {
        tempObj['basePrice'] = tempObj.price;
      }
      if (!tempObj['baseNutrition']) {
        tempObj['baseNutrition'] = tempObj.nutrition;
      }
      this.setState({ currentItemClicked: tempObj, openModal: true });
    } else {
      this.setState({ currentItemClicked: clickedItem, openModal: true });
    }
  }

  updateCartItem(clickedItem, orderItemIndex, updateItem) {
    if (this.props.orderPanelFromDashboard !== 'true') {
      this.setState({
        currentItemClicked: JSON.parse(JSON.stringify(clickedItem)),
        openModal: true,
        updateCurrentItem: true,
        updatedOrderItemIndex: orderItemIndex,
        showOutOfStock: false,
        editItem: updateItem,
        updateCartItem: updateItem,
      });
    } else {
      this.setState({ editItem: updateItem, updateCartItem: updateItem });
      this.props.updateCartItem(clickedItem, orderItemIndex);
    }
    this.props.dispatch(showMobileSidebar(false));
  }

  updateOrder(orderItems, notify) {
    const cartContents = GetCartItems(orderItems);
    const orderId = get(this.props, 'orderDetails.orderId', '');
    const userId = get(this.props, 'loginUserDetails.id', 0);
    const modeOfOrder = get(this.props, 'orderDetails.modeOfOrder', '');
    const dataname = this.props.dashboardData.dataName;
    const tokenId = this.props.tokenId;
    const jwt = this.props.jwt;

    updateCartDetails({
      order_id: orderId,
      user_id: userId,
      order_type: GetOrderType(modeOfOrder),
      delivery_fee:
        modeOfOrder === 2 ? get(this.props, 'orderDetails.deliveryFee', 0) : 0,
      cart_contents: cartContents,
      dataname,
      tokenId,
      jwt,
      locationid: this.props.dashboardData.merchantDetails.locationid,
    }).then(
      function(response) {
        getItemTaxes({
          cart_contents: GetCartItems(orderItems),
          dataname: this.props.dashboardData.dataName,
          tokenId,
          jwt,
        }).then(
          function(response) {
            this.goToCheckout(response.data.DataResponse);
            if (notify === 'addedToDag') {
              this.refs.addToCart.success(
                this.props.intl.formatMessage({
                  id: 'itemUpdatedInCart',
                  defaultMessage: defaultMsg.itemUpdatedInCart,
                })
              );
            }
          }.bind(this)
        );
      }.bind(this)
    );
  }

  removeOrderItem(itemIndex) {
    let tempArray = [...this.props.dashboardData.orderItemsList];
    tempArray.splice(itemIndex, 1);
    let cartPriceSplit = getCartPriceDetails(
      this.props,
      this.props.payMode === 'paypal' ? true : false
    );
    let orderTotal = cartPriceSplit.grandTotal;
    this.props.dispatch(removeItemFromBag(tempArray, orderTotal));
    this.props
      .dispatch(removeItemFromBag(tempArray, orderTotal))
      .then(orderItems => {
        if (orderItems.length) {
          this.updateOrder(orderItems);
        } else {
          this.goToCheckout({});
        }

        return;
      });
    this.refs.orderPanelMsg.error(
      this.props.intl.formatMessage({
        id: 'itemRemovedFromCart',
        defaultMessage: defaultMsg.itemRemovedFromCart,
      })
    );
  }

  removeAllItems() {
    alertify
      .confirm(
        this.props.intl.formatMessage({
          id: 'warning',
          defaultMessage: defaultMsg.warning,
        }),
        this.props.intl.formatMessage({
          id: 'emptyCartConfirmation',
          defaultMessage: defaultMsg.emptyCartConfirmation,
        }),
        function(result) {
          if (result) {
            this.props.dispatch(removeItemFromBag([]));
            this.refs.orderPanelMsg.error(
              this.props.intl.formatMessage({
                id: 'yourCartIsEmpty',
                defaultMessage: defaultMsg.yourCartIsEmpty,
              })
            );
          }
        }.bind(this),
        function() {}
      )
      .set('labels', {
        ok: this.props.intl.formatMessage({
          id: 'ok',
          defaultMessage: defaultMsg.ok,
        }),
        cancel: this.props.intl.formatMessage({
          id: 'cancel',
          defaultMessage: defaultMsg.cancel,
        }),
      });
  }

  changeModifiersFromDashboard(changedItem) {
    this.setState({ currentItemClicked: changedItem });
  }

  checkBoxOnchangeHandlerFromDashboard(changedItem) {
    this.setState({ currentItemClicked: changedItem });
  }

  removeCurrentItem() {
    this.setState(
      { currentItemClicked: '', updateCurrentItem: false },
      function afterNull() {}
    );
  }

  editReOrderItem(reOrderItem) {
    this.setState({
      reOrderItem: reOrderItem,
    });
    var reOrderItemData = find(this.props.reOrderItems, function(obj) {
      return obj.id === reOrderItem.id;
    });
    this.switchModal(reOrderItemData);
  }
  backToReOrder() {
    this.setState({ currentItemClicked: this.state.reOrderItem });
  }
  afterSetStateFinished() {
    this.setState({
      currentItemClicked: this.props.menuItems[0],
    });
  }
  removeCurrentOrderItem() {
    this.props.removeCI();
  }

  hideOrderTypePopup() {
    this.props.dispatch(hideOrderTypePopup());
  }
  onClose() {
    this.setState({ showOutOfStock: false });
  }

  addItemToBag(item, itemCount, cartObj) {
    const {
      dashboardData: { orderItemsList },
      payMode,
    } = this.props;
    const {
      updateCurrentItem,
      updatedOrderItemIndex,
      updateCartItem,
    } = this.state;
    this.setState({ addingToCart: true });
    let tempArray = [...orderItemsList];

    if (!updateCurrentItem) {
      if (itemCount > 1) {
        for (var i = 0; i < itemCount; i++) {
          let tempItem = JSON.parse(JSON.stringify(item));
          tempArray.push(tempItem);
        }
      } else {
        let tempItem = JSON.parse(JSON.stringify(item));
        tempArray.push(tempItem);
      }
    } else {
      if (itemCount > 1) {
        let tempItem = JSON.parse(JSON.stringify(item));
        tempArray[updatedOrderItemIndex] = tempItem;
        for (let i = 0; i < itemCount - 1; i++) {
          let tempItem = JSON.parse(JSON.stringify(item));
          tempArray.push(tempItem);
        }
      } else {
        let tempItem = JSON.parse(JSON.stringify(item));
        tempArray[updatedOrderItemIndex] = tempItem;
      }
    }
    this.setState({ updateCurrentItem: false });
    let totalCartPrice = getCartPriceDetails(
      this.props,
      payMode === 'paypal' ? true : false
    );
    checkCartItemsAvailable(cartObj, this.props)
      .then(cartStockDetails => {
        return cartStockDetails;
      })
      .then(stockDetails => {
        if (stockDetails !== false) {
          this.setState({
            showOutOfStock: true,
            showOutOfStockDetails: stockDetails,
            currentItemClicked: '',
            addingToCart: false,
          });
        } else {
          this.props
            .dispatch(
              addItemToBag(tempArray, totalCartPrice, itemCount, updateCartItem)
            )
            .then(orderItems => {
              this.setState({ updateCartItem: false });
              this.updateOrder(orderItems, 'addedToDag');
            });
          this.setState({
            currentItemClicked: '',
            addingToCart: false,
            showOutOfStock: stockDetails,
          });
        }
      });
  }

  goToCheckout(goToCheckoutResp) {
    this.props.dispatch(goToCheckout(goToCheckoutResp));
  }

  addItemsToBag(items) {
    this.setState({
      itemsarray: items,
    });
  }

  getItems() {
    return this.props.orderItems.map((item, i) => {
      if (!item) {
        return false;
      }
      return (
        <Accordion
          key={i}
          itemDetails={item}
          itemName={item ? item.item : ''}
          itemPrice={
            parseFloat(parsePrice(item.price, true)) +
            parseFloat(parsePrice(item.modify_price, true)) +
            parseFloat(parsePrice(item.forced_modifiers_price, true))
          }
          itemQty={item.quantity}
          itemIndex={i}
          switchEditModal={(clickedOrderItem, index) =>
            this.props.switchEditModal(clickedOrderItem, index)
          }
          deleteItem={(clickedDeleteItem, index) =>
            this.props.deleteItem(clickedDeleteItem, index)
          }
          expandItemList={this.expandItemList}
          switchModal={clickedItem => this.switchModal(clickedItem)}
          updateCartItem={(clickedItem, orderItemIndex, updateItem) => {
            this.updateCartItem(clickedItem, orderItemIndex, updateItem);
          }}
          removeOrderItem={itemIndex => this.removeOrderItem(itemIndex)}
        />
      );
    });
  }

  expandItemList(buttonNode) {
    let target = $('#' + buttonNode.id + '-list');
    target.slideToggle();
  }

  componentDidMount() {
    $('[id^=detail-]').hide();
    this.interval = setInterval(this.updatePannelDimensions, 300);
    window.addEventListener('resize', this.updatePannelDimensions);
  }

  componentDidUpdate() {
    $('[id^=detail-list]').hide();
  }

  goToCheckoutMethod(res) {
    if (
      res.data.DataResponse &&
      res.data.DataResponse.status &&
      res.data.DataResponse.status.toLowerCase() === 'f'
    ) {
      this.refs.addToCart.error(res.data.DataResponse.msg);
      return false;
    } else {
      this.props.dispatch(updateOrderIdDetails(res.data.DataResponse));
      browserHistory.push('/' + this.props.rname + '/checkout');
    }
  }

  updateCheckoutDetails(response) {
    this.props.dispatch(updateOrderIdDetails(response));
    this.setState({ redirectingToCheckout: false });
    browserHistory.push('/' + this.props.rname + '/checkout');
  }

  handleCheckout() {
    let cookieData = cookieValue('token');
    if (
      this.props.authenticated ||
      this.props.guest ||
      (cookieData && cookieData != '')
    ) {
      this.setState({
        checkout: false,
        loading: true,
        redirectingToCheckout: true,
      });
      setCheckout(this, true, this.updateCheckoutDetails);
    } else {
      this.props.signInModal('goToCheckout');
    }
  }

  renderCartTotal() {
    const {
      payMode,
      locationDetails,
      loginUserDetails,
      discountApplied,
    } = this.props;

    let cartPriceSplit = getCartPriceDetails(
      this.props,
      payMode === 'paypal' ? true : false
    );

    if (locationDetails) {
      return get(loginUserDetails, 'mealplan.stipend_balance', 0) === 0 &&
        discountApplied === 'meal_plan'
        ? cartPriceSplit.grandTotal - 0.1 * cartPriceSplit.grandTotal
        : cartPriceSplit.grandTotal;
    } else {
      return cartPriceSplit.grandTotal;
    }
  }

  renderMealPlanDiscount() {
    const { loginUserDetails, discountApplied } = this.props;
    return get(loginUserDetails, 'mealplan.stipend_balance', 0) === 0 &&
      discountApplied === 'meal_plan' ? (
      <div className="row discount primaryFont">
        <div className="col-md-6 col sm-6 col-xs-6 order-panel-discount-details">
          <FormattedMessage
            id="discount"
            defaultMessage={defaultMsg.discount}
          />{' '}
          :
        </div>
        <div className="col-md-6 col sm-6 col-xs-6 order-panel-discount-details order-panel-calculations-right">
          10%
        </div>
      </div>
    ) : null;
  }

  render() {
    let modeText = '';
    let orderTypeText = '';
    let addressDetails = this.props.dashboardData.locationDetails
      .selectedLocationAddress;

    switch (Number(this.props.modeOfOrder)) {
      case 1: {
        modeText = this.props.intl.formatMessage({
          id: 'pickupFrom',
          defaultMessage: defaultMsg.pickupFrom,
        });
        orderTypeText = this.props.intl.formatMessage({
          id: 'pickup',
          defaultMessage: defaultMsg.pickup,
        });
        addressDetails = this.props.selectedLocationAddress;
        break;
      }
      case 2: {
        modeText = this.props.intl.formatMessage({
          id: 'deliverTo',
          defaultMessage: defaultMsg.deliverTo,
        });
        orderTypeText = this.props.intl.formatMessage({
          id: 'delivery',
          defaultMessage: defaultMsg.delivery,
        });
        addressDetails = this.props.dashboardData.deliveryDetails
          .deliveryAddress;
        break;
      }
      case 3: {
        modeText = this.props.intl.formatMessage({
          id: 'dineInAt',
          defaultMessage: defaultMsg.dineInAt,
        });
        orderTypeText = this.props.intl.formatMessage({
          id: 'dineIn',
          defaultMessage: defaultMsg.dineIn,
        });
        addressDetails = this.props.selectedLocationAddress;
        break;
      }
      default: {
        modeText = '';
        orderTypeText = '';
        break;
      }
    }

    const itemsContent = this.getItems();
    const cartPriceSplit = getCartPriceDetails(
      this.props,
      this.props.payMode === 'paypal' ? true : false
    );

    const emptyCart = (
      <div
        className="col-md-12 emptyBag cursonPointer no-selection olo-client-theme-color"
        onClick={() => {
          this.removeAllItems();
        }}
      >
        <FormattedMessage
          id="emptyYourCart"
          defaultMessage={defaultMsg.emptyYourCart}
        />
        <span
          className="glyphicon glyphicon-shopping-cart cursonPointer olo-client-theme-color"
          style={{ paddingLeft: '10px', marginTop: '-4px' }}
        />
      </div>
    );

    const dashboardOrderPanelEmptyBag =
      this.props.orderItems.length > 0 ? (
        <div className="row order-panel">
          <div>
            {this.props.dashboardData.updatingTaxes === true ? (
              <div className="col-md-12 checkoutButton no-selection olo-client-theme-background">
                <FormattedMessage
                  id="loadingTaxText"
                  defaultMessage={defaultMsg.loadingTaxText}
                />
              </div>
            ) : (
              <div>
                {this.state.redirectingToCheckout === true ? (
                  <div className="col-md-12 checkoutButton no-selection olo-client-theme-background">
                    <FormattedMessage
                      id="redirectingToCheckout"
                      defaultMessage={defaultMsg.redirectingToCheckout}
                    />
                  </div>
                ) : (
                  <div
                    className="col-md-12 checkoutButton no-selection olo-client-theme-background"
                    onClick={this.handleCheckout.bind(this)}
                  >
                    <span>
                      <FormattedMessage
                        id="goToCheckout"
                        defaultMessage={defaultMsg.goToCheckout}
                      />{' '}
                      : &nbsp;
                      {parsePrice(cartPriceSplit.grandTotal)}
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      ) : null;

    const checkoutSubtotal = (
      <div>
        {this.props.orderItems.length > 0 ? (
          <div
            className="row checkoutButton2 no-selection olo-client-theme-background"
            style={{ cursor: 'default' }}
          >
            <strong>
              {this.props.dashboardData.updatingTaxes === true ? (
                <FormattedMessage
                  id="loadingTaxText"
                  defaultMessage={defaultMsg.loadingTaxText}
                />
              ) : (
                <span>
                  <FormattedMessage
                    id="total"
                    defaultMessage={defaultMsg.total}
                  />{' '}
                  {parsePrice(this.renderCartTotal())}
                </span>
              )}
            </strong>
          </div>
        ) : null}
      </div>
    );

    let emptyBackgroundColor = '';
    let emptyBagDeliveryFee =
      'col-md-7 col sm-7 col-xs-7 order-panel-bottom-details ';
    let orderCalulations = 'row order-calculations';
    if (this.props.orderItems.length <= 0) {
      emptyBagDeliveryFee =
        ' col-md-7 col sm-7 col-xs-7 order-panel-bottom-details emptyBag-delivery-fee';
      emptyBackgroundColor = 'side-bar-height emptyBag-background';
      orderCalulations = 'row order-calculations emptyBag-calculations';
    }
    const onCheckoutClass =
      this.props.orderPanelFromDashboard !== 'true'
        ? ' checkout-order-pannel'
        : '';
    const orderType = GetOrderType(this.props.modeOfOrder, false, false);

    const orderPanelStyles = {
      overflow: 'hidden',
      position: 'fixed',
      top: 'auto',
      bottom: 0,
      right: 0,
      height: `calc(100vh - ${this.state.topSpace}px)`,
    };

    if (this.state.isSmallerDevice) {
      orderPanelStyles['width'] = this.state.display ? '100%' : '0%';
      orderPanelStyles['height'] = '100vh';
    }

    return (
      <div className="orderPanelTop">
        <ToastContainer
          toastMessageFactory={ToastMessageFactory}
          ref="orderPanelMsg"
          className="toast-top-right"
        />
        <ToastContainer
          toastMessageFactory={ToastMessageFactory}
          ref="addToCart"
          className="toast-top-right"
        />
        <AddItemPopup
          changeModifiersFromDashboard={changedItem => {
            this.changeModifiersFromDashboard(changedItem);
          }}
          checkBoxOnchangeHandlerFromDashboard={changedItem => {
            this.checkBoxOnchangeHandlerFromDashboard(changedItem);
          }}
          editCart={this.state.editItem}
          currentItem={this.state.currentItemClicked}
          removeCI={() => this.removeCurrentItem()}
          editReOrder={reOrderItem => this.editReOrderItem(reOrderItem)}
          backToReOrder={() => this.backToReOrder()}
          updateOrderPanel={jsonresponse => this.updateOrderPanel(jsonresponse)}
          orderId={this.props.orderId}
          itemsInBag={this.props.itemsInBag}
          turnOnSpinner={(msg, type) => this.props.turnOnSpinner(msg, type)}
          openModal={this.state.openModal}
          closeModal={this.closeModal}
          itemsarray={this.state.itemsarray}
          addItemToBag={(item, itemCount, cartObj) => {
            this.addItemToBag(item, itemCount, cartObj);
          }}
          updateAddingToBag={() => {
            this.updateAddingToBag();
          }}
          addItemsToBag={items => {
            this.addItemsToBag(items);
          }}
          updateCurrentItem={this.state.updateCurrentItem}
          numberCount="1"
          addingToCart={this.state.addingToCart}
          updateCartItem={this.state.updateCartItem}
        />

        <div
          id="orderPanel"
          style={orderPanelStyles}
          className={
            'order-sidebar col-lg-3 col-md-3 col-sm-3 ' +
            this.props.orderPanelClass +
            'sideBar ' +
            emptyBackgroundColor +
            onCheckoutClass
          }
        >
          <div className="row">
            <div
              className="col-md-12 col-xs-12"
              style={{
                maxHeight:
                  this.state.scrollableHeight === '100%'
                    ? this.state.scrollableHeight
                    : this.state.scrollableHeight,
                height:
                  this.state.scrollableHeight === '100%'
                    ? this.state.scrollableHeight
                    : this.state.scrollableHeight,
                overflow: 'auto',
              }}
            >
              <div className="panel panelStyle">
                <div className="panel-body boxStyle">
                  <div className="title">
                    <FormattedMessage
                      id="yourOrder"
                      defaultMessage={defaultMsg.yourOrder}
                    />
                    {this.state.isSmallerDevice ? (
                      <div className="close-cart">
                        <i
                          onClick={this.closeCart}
                          className="fa fa-2x fa-times"
                        />
                      </div>
                    ) : null}
                  </div>
                  {(this.props.maxAdvanceDays === '0' &&
                    this.state.isNowAvialable === false &&
                    this.state.currentTimeCompare === false) ||
                  (this.props.asapTimeAvailability === '1' &&
                    this.state.isNowAvialable === false) ? (
                    <span className="order-information primaryColor primaryFont">
                      <span className="label label-danger">
                        <FormattedMessage
                          id="closed"
                          defaultMessage={defaultMsg.closed}
                        />
                      </span>
                    </span>
                  ) : null}

                  {this.props.orderItems.length > 0 ? (
                    <div>
                      {this.props.dashboardData.orderDate ? (
                        <div className="order-information">
                          <b>
                            {' '}
                            <FormattedMessage
                              id="date"
                              defaultMessage={defaultMsg.date}
                            />{' '}
                            :{' '}
                          </b>
                          {this.props.dashboardData.orderDate === 'now'
                            ? moment().format('MMM D, Y')
                            : moment(
                                Number(this.props.dashboardData.orderDate)
                              ).format('MMM D, Y')}
                        </div>
                      ) : null}
                      {orderType ? (
                        <div className="order-information">
                          <b>
                            {' '}
                            <FormattedMessage
                              id="orderType"
                              defaultMessage={defaultMsg.orderType}
                            />{' '}
                            :{' '}
                          </b>
                          {orderType}
                        </div>
                      ) : null}

                      {addressDetails ? (
                        <div className="order-information">
                          <b>{modeText} : </b>
                          {' ' + addressDetails}
                        </div>
                      ) : Number(this.props.modeOfOrder) === 2 ? (
                        <div className="order-information">
                          <FormattedMessage
                            id="pleaseSelectDeliveryAddress"
                            defaultMessage={
                              defaultMsg.pleaseSelectDeliveryAddress
                            }
                          />
                        </div>
                      ) : null}

                      {this.props.dashboardData.orderTime &&
                      parseInt(this.props.modeOfOrder) !== 2 ? (
                        <div className="order-information">
                          <b>
                            {' '}
                            <FormattedMessage
                              id="estimated"
                              defaultMessage={defaultMsg.estimated}
                            />{' '}
                            {orderType}{' '}
                            <FormattedMessage
                              id="time"
                              defaultMessage={defaultMsg.time}
                            />{' '}
                            :{' '}
                          </b>
                          {this.props.dashboardData.orderTime}
                        </div>
                      ) : null}

                      {parseInt(this.props.modeOfOrder) === 2 &&
                      this.props.deliveryTime &&
                      !this.props.isDataNameFilterForDining ? (
                        <div>
                          <div className="order-information">
                            <b>
                              {' '}
                              <FormattedMessage
                                id="estimated"
                                defaultMessage={defaultMsg.estimated}
                              />{' '}
                              {orderTypeText}{' '}
                              <FormattedMessage
                                id="time"
                                defaultMessage={defaultMsg.time}
                              />{' '}
                              :{' '}
                            </b>
                            {
                              this.props.dashboardData.locationDetails
                                .deliveryTime
                            }
                          </div>
                          <div className="order-information">
                            <b>
                              <FormattedMessage
                                id="orderMinimum"
                                defaultMessage={defaultMsg.orderMinimum}
                              />{' '}
                              :
                            </b>
                            <span>
                              {' ' +
                                parsePrice(
                                  this.props.dashboardData.merchantDetails
                                    .ltg_minimum_delivery_amount
                                )}
                            </span>
                          </div>
                        </div>
                      ) : null}
                      <div style={{ paddingTop: '10px' }}>
                        <div
                          style={{ borderTop: '1px solid #ddd', width: '100%' }}
                        />

                        <div
                          className="panel panel-default order-modifier-contailner"
                          style={{ borderLeftWidth: '0px' }}
                        >
                          <ul className="list-group">{itemsContent}</ul>
                        </div>
                        <div
                          style={{
                            borderBottom: '1px solid #ddd',
                            width: '100%',
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <div>
                      <p
                        className="empty-content"
                        style={{ paddingLeft: '40px', paddingTop: '25px' }}
                      >
                        <FormattedMessage
                          id="noItemsHaveBeenAddedToYourOrderYet"
                          defaultMessage={
                            defaultMsg.noItemsHaveBeenAddedToYourOrderYet
                          }
                        />
                      </p>
                      <div
                        style={{
                          borderBottom: '1px solid #ddd',
                          width: '100%',
                          paddingTop: '25px',
                        }}
                      />
                      <div>
                        {parseInt(this.props.modeOfOrder) === 2 &&
                        this.props.deliveryTime ? (
                          <div
                            className="mode"
                            style={{
                              paddingLeft: '10px',
                              paddingTop: '10px',
                              textAlign: 'center',
                              width: '90%',
                            }}
                          >
                            <FormattedMessage
                              id="estimated"
                              defaultMessage={defaultMsg.estimated}
                            />{' '}
                            {orderTypeText}{' '}
                            <FormattedMessage
                              id="time"
                              defaultMessage={defaultMsg.time}
                            />{' '}
                            : {this.props.deliveryTime}
                            <div>
                              <FormattedMessage
                                id="orderMinimum"
                                defaultMessage={defaultMsg.orderMinimum}
                              />{' '}
                              :
                              <span
                                style={{
                                  paddingLeft: '5px',
                                  fontWeight: 'normal',
                                }}
                              >
                                {parsePrice(
                                  this.props.dashboardData.merchantDetails
                                    .ltg_minimum_delivery_amount
                                )}
                              </span>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-md-12 col-xs-12 boxStyle">
                  <Taxes
                    tax={cartPriceSplit.inclusiveTaxes}
                    header="Included Tax"
                  />

                  {this.props.orderItems.length > 0 ? (
                    <div className="row order-calculations differentiate">
                      <div className="col-md-7 col sm-7 col-xs-7 order-panel-bottom-details">
                        <FormattedMessage
                          id="itemsSubtotal"
                          defaultMessage={defaultMsg.itemsSubtotal}
                        />{' '}
                        :
                      </div>

                      <div className="col-md-5 col sm-5 col-xs-5 order-panel-bottom-details order-panel-calculations-right">
                        {parsePrice(cartPriceSplit.subTotal)}
                      </div>

                      {cartPriceSplit.discountDetails.lavuDisplayType ===
                      'discount' ? (
                        <Discount
                          discountDetails={cartPriceSplit.discountDetails}
                          total={cartPriceSplit.total}
                          updating={this.props.dashboardData.updatingTaxes}
                        />
                      ) : null}
                    </div>
                  ) : null}
                  <Taxes tax={cartPriceSplit.exclusiveTaxes} header="Tax" />
                  {this.props.orderItems.length > 0 &&
                  Number(this.props.modeOfOrder) === 2 &&
                  this.props.dashboardData.locationDetails.delivery_fees ? (
                    <div className={orderCalulations}>
                      <div className={emptyBagDeliveryFee}>
                        <FormattedMessage
                          id="deliveryFees"
                          defaultMessage={defaultMsg.deliveryFees}
                        />{' '}
                        :
                      </div>
                      <div className="col-md-5 col sm-5 col-xs-5 order-panel-bottom-details order-panel-calculations-right">
                        {parsePrice(
                          this.props.dashboardData.locationDetails.delivery_fees
                        )}
                      </div>
                    </div>
                  ) : null}
                  {cartPriceSplit.roundingAmount !== 0 ? (
                    <div className="row order-calculations differentiate">
                      <div className="col-md-7 col sm-7 col-xs-7 order-panel-bottom-details">
                        <FormattedMessage
                          id="roundingAdjustment"
                          defaultMessage={defaultMsg.roundingAdjustment}
                        />
                      </div>
                      <div className="col-md-5 col sm-5 col-xs-5 order-panel-bottom-details order-panel-calculations-right">
                        {parsePrice(cartPriceSplit.roundingAmount)}
                      </div>
                    </div>
                  ) : null}
                  {this.props.orderItems.length > 0 &&
                  cartPriceSplit.tip.type !== '' ? (
                    this.props.orderPanelFromDashboard === 'false' ||
                    parsePrice(cartPriceSplit.tip.price) > 0 ? (
                      <div className="row order-calculations">
                        <div className="col-md-7 col sm-7 col-xs-7 order-panel-bottom-details">
                          <FormattedMessage
                            id="tip"
                            defaultMessage={defaultMsg.tip}
                          />{' '}
                          :
                        </div>
                        <div className="col-md-5 col sm-5 col-xs-5 order-panel-bottom-details order-panel-calculations-right">
                          {parsePrice(cartPriceSplit.tip.price)}
                        </div>
                      </div>
                    ) : null
                  ) : null}
                </div>
                {this.props.orderItems.length > 0 &&
                this.props.orderPanelFromDashboard === 'true'
                  ? emptyCart
                  : null}
              </div>
            </div>
          </div>
          <div className="pannel-action">
            {this.props.orderPanelFromDashboard === 'true'
              ? dashboardOrderPanelEmptyBag
              : checkoutSubtotal}
          </div>
        </div>
        {this.state.showOutOfStock ? (
          <OutOfStockItems
            outOfStockItems={this.state.showOutOfStock}
            cartItems={true}
            onClose={() => {
              this.onClose();
            }}
          />
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    loginUserDetails: state.auth.loginUserDetails,
    guest: state.auth.guest,
    dashboardData: dashboardData(state),
    tokenId: state.auth.tokenId,
    jwt: state.auth.jwt,
    discount: state.checkout.discount,
    orderDetails: getOrderDetails(state),
    isDataNameFilterForDining: isDataNameFilterForDining(state),
    menuItems: state.menuCategories.menuItems,
    reOrderItems: state.dashboard.reOrderItemsData,
    asapTimeAvailability:
      state.dashboard.merchantDetails.enable_allow_asap_orders_2,
    maxAdvanceDays: state.dashboard.merchantDetails.max_advance_days_2,
    restaurantDetails: getRestaurantDetails(state),
  };
}

OrderPanel.propTypes = {
  intl: intlShape.isRequired,
};

const Discount = props => {
  let discountDetails = props.discountDetails;

  if (!discountDetails) {
    return null;
  }

  return (
    <div>
      <PannelItem
        title={discountDetails.title}
        value={'-' + parsePrice(discountDetails.discount_value)}
        strike={false}
        updating={props.updating}
      />
    </div>
  );
};

const PannelItem = props => {
  return (
    <div className="font-small-xs">
      <div className="col-md-7 col sm-7 col-xs-7 order-panel-bottom-details">
        {props.title}
      </div>
      <div className="col-md-5 col sm-5 col-xs-5 order-panel-bottom-details order-panel-calculations-right">
        {props.strike === true ? (
          <strike> {props.value}</strike>
        ) : (
          <span>
            {props.updating === true ? (
              <span className="text-center">
                {' '}
                <FormattedMessage
                  id="loadingText"
                  defaultMessage={defaultMsg.loadingText}
                />{' '}
              </span>
            ) : (
              <span> {props.value}</span>
            )}
          </span>
        )}
      </div>
    </div>
  );
};

export default connect(
  mapStateToProps,
  dispatch => ({
    dispatch,
  })
)(injectIntl(OrderPanel));



// WEBPACK FOOTER //
// ./src/views/common/OrderPanel/OrderPanel.jsx